import React from "react";
import store from "src/store";
import ExpectedOutputDeclare from "./expected-output-declare";
import { useStepIndex } from "./step-index-context";

const CONSTS = require("shared/consts");

export default function ExpectedOutput() {

    var stepIndex = useStepIndex()
    store.useRerenderIfChange(() => [
        store.steps[stepIndex]['has_expected_output'],
        store.steps[stepIndex]['isReadOnly'],
        store.steps[stepIndex]['abi']?.length,
        store.steps[stepIndex].function_signature
    ])

    const updatedExpectedOutput = () => {
        store.steps[stepIndex]['has_expected_output'] = !store.steps[stepIndex]['has_expected_output'];
        store.updateStore();
    }

    const getThisFunctionABI = () => {
        let functionAbiObj = store.steps[stepIndex].abi?.find(x =>
            x.type == "function" &&
            x.signature == store.steps[stepIndex].function_signature
        );
        return functionAbiObj;
    }

    return (
        <>
            {(store.steps[stepIndex].type == CONSTS.STEP_TYPES.CHECk_BALANCE ||
                (store.steps[stepIndex].type == CONSTS.STEP_TYPES.ENCODE_TRANSACTION && 
                    (getThisFunctionABI() && getThisFunctionABI().hasOwnProperty('outputs') && getThisFunctionABI().outputs?.length))) &&
                <div css="background: white;padding-left: 10px;padding-top:10px; height: calc(100% - 20px);">
                    <div css={`display:flex;`}>
                        <div css={`flex-shrink:0;width:110px;`}>
                            Expected Output
                        </div>
                        <div>

                            <span css="font-weight: 700">{store.steps[stepIndex]['has_expected_output'] ?
                                'There is expected output' : 'There is no expected output'}</span>
                            {
                                !store.isReadOnly &&
                                <span css={`
                                color:#799fd4;
                                cursor: pointer;
                                margin-left:6px;
                                font-size:13px;
                                text-decoration-line: underline;
                                justify-self: right;
                            `}
                                    onClick={() => {
                                        store.removeResults(stepIndex)
                                        updatedExpectedOutput()
                                    }}>Change</span>}
                        </div>

                    </div>

                    {
                        store.steps[stepIndex]['has_expected_output'] ?
                            <>
                                <ExpectedOutputDeclare getThisFunctionABI={() => getThisFunctionABI()} />
                            </> : <></>
                    }


                </div> || null}
        </>
    )
}